'use client';

import RecommendationWidget from '@/components/recommendationWidget/RecommendationWidget';
import type { ComponentRecommendationWidgetStoryblok } from '@/types/component-types-sb';

const RecommendationWidgetStory: React.FC<{ blok: ComponentRecommendationWidgetStoryblok }> = ({ blok }) => (
  <RecommendationWidget {...blok} />
);

export default RecommendationWidgetStory;
